<template>
  <section class="cw-panel">
    <h3>Bankzahlungen abgleichen</h3>
    <p class="cw-small cw-top-space">Kassen- und Vertragsrechnungen werden gemeinsam unter Kasse → Rechnungen → Bankeingänge abgeglichen. Dort kannst du die Zuordnung prüfen, offene Eingänge klären und Korrekturen nachvollziehen.</p>
    <router-link class="cw-button cw-primary" :to="{ name: 'posInvoices', query: { collections: 'bank' } }">Bankeingänge öffnen</router-link>
    <p class="cw-small cw-top-space">Für diesen Arbeitsbereich ist die Kassenberechtigung erforderlich.</p>
  </section>
</template>
<script>
export default {}
</script>
